import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";
import Chart from "../../components/Chart"
import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { ImpactSummaryApi } from "../../store/analytics/impactSummary";
import { ThemeContext } from '../../context/ThemeContext';
import dayjs from "dayjs";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import { AiOutlineBell } from 'react-icons/ai'

const ImpactSummaryColumns = [
    {
        field: "id",
        headerName: "ID",
        width: 120,
        filterable: false,
        sortable: true,
        disableColumnMenu: true,
    },
    {
        field: "title",
        headerName: "Title",
        width: 200,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "language",
        headerName: "Language",
        width: 200,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "state",
        headerName: "State",
        width: 200,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "users_enrollment_count",
        headerName: "Users Enrollment Count",
        width: 220,
        filterable: false,
        sortable: true,
        disableColumnMenu: true,
    },
    {
        field: "total_certificates",
        headerName: "Total Certificates",
        width: 200,
        filterable: false,
        sortable: true,
        disableColumnMenu: true,
    },
    {
        field: "completion_percent",
        headerName: "Completion Percent (%)",
        width: 220,
        filterable: false,
        sortable: true,
        disableColumnMenu: true,
        renderCell: (data) => (<>
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.completion_percent.toFixed(2)}</Typography>
        </>)
    },
    {
        field: "average_marks",
        headerName: "Average Marks",
        width: 200,
        filterable: false,
        sortable: true,
        disableColumnMenu: true,
    },
];




export default function ImpactSummary({ graphData, region, state, loading, type, module, monthDaily, startDate, endDate, isMaskingEnabled, schoolType, platform, userType, language }) {
    const [activevsavgtimespent, setActiveVsAvgTimeSpent] = useState({ l1: true, l2: true });
    const [teacherRegister, setTeacherRegistration] = useState({ l1: true, l2: true, l3: true, l4: true });
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const [isDownload, setIsDownload] = useState(false)
    const impactSummaryTable = useSelector((state) => state?.impactSummaryTable);
    const { result: tableResult, loading: tableLoading, total } = impactSummaryTable;
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    const toggleTeacherRegistration = useCallback((key) => {
        setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const toggleActiveVsAvgTimeSpent = useCallback((key) => {
        setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);

    const transformGraphData = useMemo(() => {
        const chartData = Array.isArray(graphData?.enrollment_stats)
            ? graphData?.enrollment_stats.map(item => ({
                name: item.month || item.name,
                "Total Certificates": item.total_certificates || 0,
                "Total Enrollments": item.total_enrollments || 0,
            }))
            : [];
        return chartData;

    }, [graphData, type]);

    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                // module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                // module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                state: state,
                city: region,
                sort_order: "desc",
                state: state,
                start_date: startDate,
                end_date: endDate,
                language: language,
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(ImpactSummaryApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, startDate, endDate, isMaskingEnabled, schoolType, language]);


    return (
        <>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                <Typography variant="h3">Impact Summary</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Grid container spacing={1}>
                    {graphData?.total_data && Object.entries(graphData.total_data).map(([data, value], index) => {
                        return (
                            <Grid item xs={6} sm={6} md={6} lg={3} mb={1} key={index}>
                                <Box
                                    className='customCard1'
                                    sx={{
                                        transition: 'none !important',
                                        '&:hover': {
                                            transform: 'none !important',
                                        },
                                    }}
                                >
                                    <Stack direction='row' alignItems='center' spacing={1}>
                                        <Box sx={{ fontSize: 25 }}>
                                            <AiOutlineBell size={25} />
                                        </Box>
                                        <Stack>
                                            <Typography sx={{ textTransform: "capitalize" }}>{data.replaceAll("_", " ")}</Typography>
                                            <Typography variant='h4' fontWeight={600}>{value}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Chart type={"line"} height={500} data={transformGraphData} module={'impactSummary'} lineState={teacherRegister} />
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                <DataGridComponent
                    disableColumnMenu
                    disableColumnSorting
                    loading={tableLoading}
                    rowCount={total}
                    pageSize={paginationModel?.pageSize}
                    onPageSizeChange={(newPageSize) => {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: newPageSize,
                        })
                    }}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    sx={{
                        height: 500
                    }}
                    rows={tableResult}
                    getRowId={(r) => {
                        return module === "course" ? r['s.no'] : r['id']
                    }}
                    getRowSpacing={getRowSpacing}
                    columns={ImpactSummaryColumns}
                    onSortModelChange={handleSortModelChange}
                    onFilterModelChange={onFilterChange}
                    slots={{
                        noRowsOverlay: () => (
                            <Box className="noData">
                                <img src={NodataImg} alt="no data found" />
                            </Box>
                        ),
                        toolbar: (props) =>
                        (CustomGridToolbar({
                            ...props, moduleType: "ImpactSummary",
                            queryOptions: queryOptions,
                            paginationModel: paginationModel,
                            isDownload: isDownload,
                            setIsDownload: setIsDownload,
                            apiUrl: apiRoutes.impactSummaryCsvExport,
                            hasfilter: false,
                            hasSearch: false,
                            download_csv: true,
                            additionalQueryParams: {
                                school_type: schoolType,
                                language: language,
                                state: state,
                                city: region,
                                start_date: startDate,
                                end_date: endDate,
                            }
                        })),
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'linear-progress',
                        },
                        toolbar: {
                            showQuickFilter: true,
                        },
                        pagination: {
                            labelDisplayedRows: () => null,
                            sx: {
                                "& .MuiTablePagination-actions": {
                                    marginLeft: -5
                                }
                            }
                        }
                    }}
                />
            </Stack>
            <BackdropUI open={isDownload} />
        </>)
}

